import React from 'react';
import { SVGIconProps } from './props';

const CartSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M11.1418 14.4258C11.8428 14.4258 12.4111 14.9903 12.4111 15.6875C12.4111 16.3839 11.8428 16.948 11.1418 16.948C10.4406 16.948 9.87204 16.3839 9.87204 15.6875C9.87204 14.9902 10.4406 14.4258 11.1418 14.4258Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M4.04637 14.4258C4.74751 14.4258 5.31592 14.9903 5.31592 15.6875C5.31592 16.3839 4.74751 16.948 4.04637 16.948C3.34541 16.948 2.77682 16.3839 2.77682 15.6875C2.77682 14.9902 3.34541 14.4258 4.04637 14.4258Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M13.3816 3.82059L14.1001 0.996343L18.9758 0.0517578L19 0.175102V2.02664L15.6924 2.66732L12.9492 13.4501H2.23413L0 4.42522L13.3816 3.82059ZM3.76723 11.5072H11.426L12.881 5.78817L2.46807 6.25873L3.76723 11.5072Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
            </svg>
        </span>
    );
};

export default CartSVGIcon;
